export var DEPLOY_DATE = new Date('2025-12-23T13:59:51+0000');
